import useInvoice from '@/modules/invoice/application/invoice';
import { convertNumberToCurrency } from '@/utility/helper/common';
import { isValidDateString } from '@/utility/helper/dateUtils';
import dayjs from 'dayjs';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useSnackbar,
} from '@rrexpress/core';
import React, { useEffect, useState } from 'react';
import { IPayment } from '@/modules/invoice/model/invoice';

const InvoicePaymentTable: React.FC<{ id: string }> = ({ id }) => {
  const [paymentData, setPaymemtData] = useState<IPayment[]>([]);

  const { getPaymentById } = useInvoice();
  const { show } = useSnackbar();

  function getDetailPayment() {
    getPaymentById(id)
      .then((res) => {
        setPaymemtData(res?.data);
      })
      .catch((res) => {
        show(res?.err, 'error');
      })
      .finally(() => {
      });
  }

  useEffect(() => {
    getDetailPayment();
  }, []);

  return (
    <div className="relative">
      <div className="mb-8">
        <Table className="!table">
          <TableHead>
            <TableRow>
              <TableCell>No</TableCell>
              <TableCell>Tanggal Pembayaran</TableCell>
              <TableCell>Nomor Pembayaran</TableCell>
              <TableCell>Metode Pembayaran</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paymentData?.map?.((item: IPayment, index: number) => (
              <TableRow>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{isValidDateString(item?.payment_date_time_utc) ? dayjs(item?.payment_date_time_utc).format('DD MMMM YYYY') : '-'}</TableCell>
                <TableCell>{item?.payment_number}</TableCell>
                <TableCell>{item?.payment_method || '-'}</TableCell>
                <TableCell>
                  <div className="text-right">
                    {convertNumberToCurrency(item?.allocated_amount || 0)}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default InvoicePaymentTable;
